import { render } from "./BlogPhoto1.vue?vue&type=template&id=6347d678&scoped=true"
import script from "./BlogPhoto1.vue?vue&type=script&lang=js"
export * from "./BlogPhoto1.vue?vue&type=script&lang=js"

import "./BlogPhoto1.vue?vue&type=style&index=0&id=6347d678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6347d678"]])

export default __exports__